// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"977":"7a6b0991","1210":"5fe717c3","1577":"7a6b0991","2778":"5fe717c3","2793":"c698e469","3287":"7a6b0991","4608":"5fe717c3","4840":"5fe717c3","8266":"7a6b0991","9628":"5c0f1342"}[chunkId] + ".chunk.css";
};